import { createSlice } from '@reduxjs/toolkit';

import { DEFAULT_TEMPLATE_WCA_STATE } from '../../../constants/defaultStates/template-wca';
import {
  createTemplate_WCA,
  getTemplateById_WCA,
  getTemplates_WCA,
  getWhatsAppTemplateLibrary_WCA,
} from './template-action';

const getTemplateLibraryRows = (payload) => payload?.rows || [];

const getTemplateLibraryCursor = (payload) => payload?.paging?.cursors?.after || null;

export const templateSlice = createSlice({
  name: 'template',
  initialState: DEFAULT_TEMPLATE_WCA_STATE,
  reducers: {
    changeTemplatePage(state, action) {
      state.pageNo = action.payload;
    },
    changeTemplateType(state, action) {
      state.selectcampaignType = action.payload;
    },
    changeTemplateLimit(state, action) {
      state.limit = action.payload;
    },
    changeSelectedTemplate(state, { payload }) {
      state.selectedTemplate = payload;
    },
    changeTemplateMode(state, { payload }) {
      state.templateMode = payload;
    },
    showTemplateForm(state) {
      state.templateFormModule = true;
    },
    closeTemplateForm(state) {
      state.templateFormModule = false;
      state.selectedTemplate = null;
      state.templateMode = 'create';
    },
    resetSelectedTemplate(state) {
      state.selectedTemplate = null;
      state.templateMode = DEFAULT_TEMPLATE_WCA_STATE.templateMode;
      state.selectcampaignType = null;
    },
    addUTemplate(state, action) {
      if (!state.templateList.find((x) => x.templateId === action.payload.templateId)) {
        state.templateList = [action.payload, ...state.templateList];
      }
    },
    resetPage(state) {
      state.pageNo = DEFAULT_TEMPLATE_WCA_STATE.pageNo;
      state.limit = DEFAULT_TEMPLATE_WCA_STATE.limit;
    },
    clearTemplateLibrary(state) {
      state.templateLibraryList = [];
      state.templateLibraryCursor = null;
      state.templateLibraryError = null;
      state.templateLibraryLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTemplates_WCA.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTemplates_WCA.fulfilled, (state, { payload }) => {
      const templateRows = payload?.rows || [];

      state.loading = false;
      state.templateList = templateRows;
      state.totalTemplatesCount = payload?.count || 0;
    });
    builder.addCase(getTemplates_WCA.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });

    builder.addCase(createTemplate_WCA.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createTemplate_WCA.fulfilled, (state, { payload }) => {
      state.loading = false;
      // state.templateList = [payload, ...state.templateList];
      state.totalTemplatesCount += 1;
    });
    builder.addCase(createTemplate_WCA.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });

    builder.addCase(getTemplateById_WCA.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTemplateById_WCA.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.selectedTemplate = payload;
    });
    builder.addCase(getTemplateById_WCA.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });

    builder.addCase(getWhatsAppTemplateLibrary_WCA.pending, (state, action) => {
      state.templateLibraryLoading = true;
      state.templateLibraryError = null;

      if (!action.meta.arg?.append) {
        state.templateLibraryList = [];
        state.templateLibraryCursor = null;
      }
    });
    builder.addCase(getWhatsAppTemplateLibrary_WCA.fulfilled, (state, action) => {
      const libraryTemplates = getTemplateLibraryRows(action.payload);
      const shouldAppend = Boolean(action.meta.arg?.append);

      state.templateLibraryLoading = false;
      state.templateLibraryList = shouldAppend
        ? [...state.templateLibraryList, ...libraryTemplates]
        : libraryTemplates;
      state.templateLibraryCursor = getTemplateLibraryCursor(action.payload);
    });
    builder.addCase(getWhatsAppTemplateLibrary_WCA.rejected, (state, { payload }) => {
      state.templateLibraryLoading = false;
      state.templateLibraryError = payload;
    });
  },
});

export const {
  changeTemplatePage,
  changeTemplateType,
  changeTemplateLimit,
  changeSelectedTemplate,
  changeTemplateMode,
  showTemplateForm,
  closeTemplateForm,
  resetSelectedTemplate,
  addUTemplate,
  resetPage,
  clearTemplateLibrary,
} = templateSlice.actions;

export default templateSlice.reducer;
